// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay - Full screen with dark filter */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

/* Modal Container - Centered modal box */
.modal-container {
  background: white;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.24) 0px 1px 4px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalAppear 0.2s ease-out;
  font-family: 'Roboto', sans-serif;
}

/* Top Bar - Visual element for default modals */
.modal-top-bar {
  height: 24px;
  background-color: rgba(155, 155, 155, 1);
  flex-shrink: 0;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Modal Sizes */
.modal-small {
  width: 320px;
  min-height: 180px;
}

.modal-medium {
  width: 480px;
  min-height: 220px;
}

.modal-large {
  width: 640px;
  min-height: 300px;
}

/* Modal Header */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px 24px;
  border-bottom: none;
}

.modal-header.centered {
  justify-content: center;
}

.modal-title-container {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  width: 100%;
}

.modal-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.modal-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.modal-icon-error {
  color: var(--netsfere-red);
}

.modal-icon-warning {
  color: var(--netsfere-red);
}

.modal-icon-info {
  color: #2196f3;
}

.modal-icon-confirm {
  color: rgba(0, 0, 0, 0.54);
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.modal-close-button:hover {
  background-color: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.87);
}

/* Modal Content */
.modal-content {
  flex: 1;
  padding: 20px 24px;
  overflow-y: auto;
}

.modal-content.custom {
  padding: 0;
}

.modal-text {
  font-size: 18px;
  line-height: 1.6;
  color: black;
  font-weight: 400;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.modal-text p {
  margin: 0 0 12px 0;
}

.modal-text p:last-child {
  margin-bottom: 0;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  gap: 8px;
  padding: 16px 24px 20px 24px;
  justify-content: center;
  border-top: none;
}

/* Modal Buttons */
.modal-button {
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 88px;
  font-family: 'Roboto', sans-serif;
}

.modal-button-cancel {
  background-color: white;
  color: rgba(106, 106, 106, 1);
  border: 1px solid rgba(106, 106, 106, 1);
}

.modal-button-cancel:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-color: rgba(106, 106, 106, 1);
}

.modal-button-confirm {
  background-color: var(--netsfere-red);
  color: white;
}

.modal-button-confirm:hover {
  background-color: rgb(200, 62, 78);
}

/* Modal Type Variations */
.modal-error .modal-button-confirm {
  background-color: var(--netsfere-red);
}

.modal-error .modal-button-confirm:hover {
  background-color: rgb(200, 62, 78);
}

.modal-warning .modal-button-confirm {
  background-color: var(--netsfere-red);
  color: white;
}

.modal-warning .modal-button-confirm:hover {
  background-color: rgb(200, 62, 78);
}

.modal-info .modal-button-confirm {
  background-color: var(--netsfere-red);
}

.modal-info .modal-button-confirm:hover {
  background-color: rgb(200, 62, 78);
}

.modal-confirm .modal-button-confirm {
  background-color: var(--netsfere-red);
}

.modal-confirm .modal-button-confirm:hover {
  background-color: rgb(200, 62, 78);
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 16px;
  }

  .modal-small,
  .modal-medium,
  .modal-large {
    width: 100%;
    max-width: 400px;
  }

  .modal-header {
    padding: 20px 20px 12px 20px;
  }

  .modal-content {
    padding: 16px 20px;
  }

  .modal-footer {
    padding: 12px 20px 20px 20px;
    flex-direction: column-reverse;
  }

  .modal-button {
    width: 100%;
  }

  .modal-title {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iDAAiD;EACjD,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Modal Overlay - Full screen with dark filter */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Modal Container - Centered modal box */\n.modal-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.24) 0px 1px 4px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalAppear 0.2s ease-out;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Top Bar - Visual element for default modals */\n.modal-top-bar {\n  height: 24px;\n  background-color: rgba(155, 155, 155, 1);\n  flex-shrink: 0;\n}\n\n@keyframes modalAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Modal Sizes */\n.modal-small {\n  width: 320px;\n  min-height: 180px;\n}\n\n.modal-medium {\n  width: 480px;\n  min-height: 220px;\n}\n\n.modal-large {\n  width: 640px;\n  min-height: 300px;\n}\n\n/* Modal Header */\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 16px 24px;\n  border-bottom: none;\n}\n\n.modal-header.centered {\n  justify-content: center;\n}\n\n.modal-title-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n  width: 100%;\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: rgba(74, 74, 74, 1);\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.modal-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.modal-icon-error {\n  color: var(--netsfere-red);\n}\n\n.modal-icon-warning {\n  color: var(--netsfere-red);\n}\n\n.modal-icon-info {\n  color: #2196f3;\n}\n\n.modal-icon-confirm {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 0, 0, 0.54);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  transition: background-color 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.modal-close-button:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n  color: rgba(0, 0, 0, 0.87);\n}\n\n/* Modal Content */\n.modal-content {\n  flex: 1;\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.modal-content.custom {\n  padding: 0;\n}\n\n.modal-text {\n  font-size: 18px;\n  line-height: 1.6;\n  color: black;\n  font-weight: 400;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.modal-text p {\n  margin: 0 0 12px 0;\n}\n\n.modal-text p:last-child {\n  margin-bottom: 0;\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  gap: 8px;\n  padding: 16px 24px 20px 24px;\n  justify-content: center;\n  border-top: none;\n}\n\n/* Modal Buttons */\n.modal-button {\n  padding: 8px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 88px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.modal-button-cancel {\n  background-color: white;\n  color: rgba(106, 106, 106, 1);\n  border: 1px solid rgba(106, 106, 106, 1);\n}\n\n.modal-button-cancel:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n  border-color: rgba(106, 106, 106, 1);\n}\n\n.modal-button-confirm {\n  background-color: var(--netsfere-red);\n  color: white;\n}\n\n.modal-button-confirm:hover {\n  background-color: rgb(200, 62, 78);\n}\n\n/* Modal Type Variations */\n.modal-error .modal-button-confirm {\n  background-color: var(--netsfere-red);\n}\n\n.modal-error .modal-button-confirm:hover {\n  background-color: rgb(200, 62, 78);\n}\n\n.modal-warning .modal-button-confirm {\n  background-color: var(--netsfere-red);\n  color: white;\n}\n\n.modal-warning .modal-button-confirm:hover {\n  background-color: rgb(200, 62, 78);\n}\n\n.modal-info .modal-button-confirm {\n  background-color: var(--netsfere-red);\n}\n\n.modal-info .modal-button-confirm:hover {\n  background-color: rgb(200, 62, 78);\n}\n\n.modal-confirm .modal-button-confirm {\n  background-color: var(--netsfere-red);\n}\n\n.modal-confirm .modal-button-confirm:hover {\n  background-color: rgb(200, 62, 78);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modal-overlay {\n    padding: 16px;\n  }\n\n  .modal-small,\n  .modal-medium,\n  .modal-large {\n    width: 100%;\n    max-width: 400px;\n  }\n\n  .modal-header {\n    padding: 20px 20px 12px 20px;\n  }\n\n  .modal-content {\n    padding: 16px 20px;\n  }\n\n  .modal-footer {\n    padding: 12px 20px 20px 20px;\n    flex-direction: column-reverse;\n  }\n\n  .modal-button {\n    width: 100%;\n  }\n\n  .modal-title {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
